module.exports = __webpack_public_path__ + "img/coupons-stat.99de22fc.svg";